<template>
  <div>
    QUOTA LEAVE
    <hr>
    <b-form-group :class="{'error-input' : $v.data_quota_leave.title.$error}">
      <label> Quota Leave Title </label>
      <j-input
        v-model="$v.data_quota_leave.title.$model"
        :max-length="255"
        placeholder="Quota Leave Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeQuotaLeave">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveQuotaLeave">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_quota_leave: {
      title: {
        required,
      },
    },
  },
  data() {
    return {
      data_quota_leave: {
        title: '',
      },
    };
  },
  computed: {
    generateDataQuotaLeave() {
      const infoName = this.data_quota_leave.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_quota_leave.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
      };
      return data;
    },

    generateDataQuotaLeaveUpdate() {
      const infoName = this.data_quota_leave.title;
      const data = {
        info: JSON.stringify({
          name: infoName,
        }),
        name: this.data_quota_leave.title,
        widget_master_id: this.dataMaster.id,

        type: 1,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_quota_leave.title = JSON.parse(this.dataEdit.info).name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),

    saveQuotaLeave() {
      this.$v.data_quota_leave.$touch();
      if (!this.$v.data_quota_leave.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateDataQuotaLeave;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataQuotaLeaveUpdate;
          this.updateWidget({ widgetId, dataParam });
        }
        this.closeQuotaLeave();
      }
    },

    closeQuotaLeave() {
      this.$emit('close-field');
      this.data_quota_leave.title = null;
      setTimeout(() => {
        this.$v.data_quota_leave.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jQuotaLeaveSetup.vue